/** @ignore */
export default {
    debug: process.env.NODE_ENV != 'production',
    logPrefix: 'escshopify',
};



// WEBPACK FOOTER //
// ./src/config.js